const SectionHeader = ({ children }) => (
  <h2 className="text-base lg:text-lg 2xl:text-2xl md:text-base font-semibold mt-6 mb-2 text-amber-600">
    {children}
  </h2>
);

export default SectionHeader;
